export class LoadAccountStatsAction {
  static readonly type = '[Account Stats] Load account stats';
};